import React from "react"
import Select from "react-select"
import { Query } from "react-apollo"
import gql from "graphql-tag"
import { debounce } from "throttle-debounce"

class VendorSelect extends React.PureComponent {
  constructor(props) {
    super(props)
    this.handleInputChange = debounce(100, this.props.handleInputChange)
  }

  render() {
    return (
      <Query
        query={GET_VENDORS}
        variables={{ limit: 5, search: this.props.search }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (data && data.vendors) {
            let vendors = data.vendors
            if (!vendors) {
              vendors = [{ name: "" }]
            }
            let vendorOptions = vendors.map((elem) => {
              return {
                value: elem.name,
                label: elem.name,
                slug: elem.slug,
                id: elem.id,
              }
            })
            let defaultVendorOptions = this.props.vendorsMentioned.map(
              (elem) => {
                return {
                  value: elem.name,
                  label: elem.name,
                  slug: elem.slug,
                  id: elem.id,
                }
              }
            )
            return (
              <Select
                isMulti
                name="colors"
                placeholder="Select all related vendors"
                options={vendorOptions}
                onInputChange={this.handleInputChange}
                onChange={this.props.handleChange}
                defaultValue={defaultVendorOptions}
              />
            )
          }
          if (loading) return "Loading..."
          if (error) return `Error! ${error.message}`
        }}
      </Query>
    )
  }
}

const GET_VENDORS = gql`
  query GET_VENDORS($search: String) {
    vendors(search: $search) {
      id
      name
      slug
    }
  }
`

export default VendorSelect
